
import * as React from "react";

import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { ImageButtonProps, ImageButtonState } from "./imagebuttoncomponent";
import { ImageButtonCSSStyle } from "./imagebuttoncss";


export class ImageButtonView extends UIComponentViewImpl<UIDataModel>{

    draw(uiProps: ImageButtonProps, uiState: ImageButtonState, cssStyle: ImageButtonCSSStyle): JSX.Element | boolean{
        super.draw(uiProps, uiState, cssStyle);
        
        return(
            <button style={uiState.style.getImageButtonStyle()} onClick={uiProps.onClick}>
                <img style={uiState.style.getImageIconButtonStyle()} src={uiProps.context.getResources().getImage("profile.svg")}/>
                <label style={uiState.style.getImageButtonText()}>{uiState.label}</label><br/>
            </button> 
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/imagebutton/imagebuttonview.tsx